export default __webpack_public_path__ + "static/media/000_intro_part1.hevc.09814fa7.mp4";